import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = '/silver-price.php';

export function getSilverPrice(setData) {

    api.get(`${service_path}`)
        .then(response => {

            const { data } = response;

            if (data.success) {
                setData(data.price);
            } else {
                globalToast.error("Houve um erro ao carregar o conteúdo desta página!");
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error("Houve um erro ao executar essa ação!");
        });
};

export function updateSilverPrice(data, setData) {

    api.put(service_path, { price: data })
        .then(response => {

            const { data } = response;

            if (data.success) {
                setData(data.new_price)
                globalToast.success("Cotação editada com sucesso!");
            } else {
                globalToast.error("Houve um erro editar essa cotação!");
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error("Houve um erro ao executar essa ação!");
        });
};